import React from 'react';
import SubTitle from '../components/SubTitle'
import config from '../dummy_data/configuration.json';

const About = ({item}) => {
	console.log(item.CompanyProfile);
	return (
		<div className="block-content">
			<SubTitle title="关于我们" subTitle="ABOUT" />
	      	<div className="about">
	      		<div className="about-left">
	      			<img src={config.rootSite + item.ImageA} alt=""></img>
	      			<p>{item.CompanyProfile}</p>
	      		</div>
	      		<div className="about-right">
		      		<div>	      			
		      			<div className="bg-grey">
		      				<img src={config.rootSite + item.ImageB} alt=""></img>
		      			</div>
		      			<div className="bg-blue">
		      				<img src={config.rootSite + item.ImageC} alt=""></img>
		      			</div>
		      		</div>
		      		<div>
		      			<div className="bg-blue">
		      				<img src={config.rootSite + item.ImageD} alt=""></img>
		      			</div>
		      			<div className="bg-blue">
		      				<img src={config.rootSite + item.ImageE} alt=""></img>
		      			</div>
		      		</div>
	      		</div>
	      		
	      	</div>
		</div>
	);
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js